import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import authGuard from "./guards/auth";
import facebookGuard from "./guards/facebook";
import onBoardGuard from "./guards/onBoard";
import inviteGuard from "./guards/invite";
import flashGuard from "./guards/flash";
import chainGuard from "./guards/chain";
import walkthroughGuard from "./guards/walkthrough";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(flashGuard);

chainGuard.add(facebookGuard, { name: "facebook" });
chainGuard.add(authGuard, { name: "auth" });
chainGuard.add(inviteGuard, { name: "invite" });
chainGuard.add(onBoardGuard, { name: "onBoard" });
chainGuard.add(walkthroughGuard, { name: "videoWalkthrough" });

router.beforeEach(chainGuard);

export default router;
